import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NzIconService } from 'ng-zorro-antd/icon';
import * as IconSvgs from '../iconSvgs';

@Component({
  selector: 'bcsc-digi-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent implements OnChanges {

  @Input() type = '';
  @Input() color = '';

  constructor(
    private nzIconService: NzIconService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    const type = changes['type'];
    if (type && type.currentValue) {
      const iconSvgs: { [props: string]: string } = IconSvgs;
      const iconType: string = type.currentValue.replace(/-/g, '').toUpperCase();
      this.nzIconService.addIconLiteral(`ng-zorro:${type.currentValue}`, iconSvgs[iconType]);

    }
  }
}
